<div class="main-content" [class.loading-section]="isUpdating$ | async">
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0">{{ website.type }} <ng-container i18n>Components</ng-container></h6>
    </div>
    <div class="flex-fill"></div>
    <button (click)="onSave(form)" type="button" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info">
      <span class="cs-icon cs-icon-save"></span> <ng-container i18n>Save</ng-container>
    </button>
  </div>

  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="container-box details-box overflow-hidden">
      <div class="box-body" *ngIf="website.type === websiteTypes.RentalWebsite">
        <h6 class="section-title border-top-0" i18n>Enable or disable sections of the website.</h6>
        <div class="row px-3">
          <div class="col-sm-3" *ngIf="!disabledSettingsForTemplate?.location">
            <mat-checkbox formControlName="location" class="mt-primary">
              <ng-container i18n>Location Page</ng-container>
            </mat-checkbox>
          </div>
          <div class="col-sm-3" *ngIf="!disabledSettingsForTemplate?.footermap">
            <mat-checkbox formControlName="footermap" class="mt-primary">
              <ng-container i18n>Mini Footer Map</ng-container>
            </mat-checkbox>
          </div>
          <div class="col-sm-3" *ngIf="!disabledSettingsForTemplate?.price">
            <mat-checkbox formControlName="price" class="mt-primary">
              <ng-container i18n>Price List</ng-container>
            </mat-checkbox>
          </div>
        </div>
        <div class="row px-3">
          <div class="col-sm-3" *ngIf="!disabledSettingsForTemplate?.calendar">
            <mat-checkbox formControlName="calendar" class="mt-primary">
              <ng-container i18n>Availability Calendar</ng-container>
            </mat-checkbox>
          </div>
          <div class="col-sm-3" *ngIf="!disabledSettingsForTemplate?.gallery">
            <mat-checkbox formControlName="gallery" class="mt-primary">
              <ng-container i18n>Photo Gallery Page</ng-container>
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div class="box-body" *ngIf="website.type === websiteTypes.GuestPortal">
        <h6 class="section-title border-top-0" i18n>Enable or disable sections of the website.</h6>
        <div class="row px-3">
          <div class="col-sm-3">
            <mat-checkbox formControlName="directions" class="mt-primary">
              <ng-container i18n>Directions</ng-container>
            </mat-checkbox>
          </div>
          <div class="col-sm-3">
            <mat-checkbox formControlName="gallery" class="mt-primary">
              <ng-container i18n>Photos</ng-container>
            </mat-checkbox>
          </div>
        </div>
        <div class="row px-3">
          <div class="col-sm-3">
            <mat-checkbox formControlName="map" class="mt-primary">
              <ng-container i18n>Map</ng-container>
            </mat-checkbox>
          </div>
          <div class="col-sm-3">
            <mat-checkbox formControlName="weather" class="mt-primary">
              <ng-container i18n>Weather</ng-container>
            </mat-checkbox>
          </div>
        </div>
      </div>

      <div class="box-body">
        <h6 class="section-title border-top-0" i18n>Enable analytics and tracking.</h6>
        <div class="row px-3">
          <div class="col-sm-12">
            <mat-form-field2
              class="mat-block"
              i18n-matTooltip
              matTooltip="Enter your Google Analytics tracking id and your website will track visitor activity into your GA account. Example, UA-100557501-1."
              matTooltipPosition="above"
            >
              <input matInput formControlName="ga" i18n-placeholder placeholder="Google Analytics Tracking ID:" />
            </mat-form-field2>
          </div>
          <div class="col-sm-12">
            <mat-form-field2
              class="mat-block"
              i18n-matTooltip
              matTooltip="Enter your project token to start tracking customer interactions using mixpanel."
              matTooltipPosition="above"
            >
              <input matInput formControlName="mixpanel" i18n-placeholder placeholder="Mixpanel Project Token:" />
            </mat-form-field2>
          </div>
          <div class="col-sm-12">
            <mat-form-field2
              class="mat-block"
              i18n-matTooltip
              matTooltip="Enter your Facebook pixel ID to start tracking customer interactions using Facebook. We currently only track the pageview event."
              matTooltipPosition="above"
            >
              <input matInput formControlName="fbpixel" i18n-placeholder placeholder="Facebook Pixel ID:" />
            </mat-form-field2>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
